/* eslint-disable @typescript-eslint/no-explicit-any */
import { MergedProperty, PropertyRenderConfig } from '../../types';
import { mapPropertyToRenderConfig } from '../../utils/propertyMapper';
import TextBoxItem from './TextBoxItem';
import SelectBoxItem from './SelectBoxItem';
import SwitchItem from './SwitchItem';
import TableBoxItem from './TableBoxItem';
import DayRangeItem from './DayRangeItem';

interface SettingItemProps {
    item: MergedProperty;
    kidGroupList: any[];
    proPackagingCache: any[];
    invoiceForm: any[];
    onChange: (value: any, code: string) => void;
}

/**
 * Dispatcher: chọn đúng component render theo item config
 */
const SettingItem = ({
    item,
    kidGroupList,
    proPackagingCache,
    invoiceForm,
    onChange,
}: SettingItemProps) => {
    const config: PropertyRenderConfig = mapPropertyToRenderConfig(
        item,
        kidGroupList,
        proPackagingCache,
        invoiceForm,
    );

    switch (config.componentType) {
        case 'textBox':
            return (
                <TextBoxItem
                    item={item}
                    colClass={config.colClass}
                    dataType={config.dataType}
                    onChange={onChange}
                />
            );
        case 'selectBox':
            return (
                <SelectBoxItem
                    item={item}
                    colClass={config.colClass}
                    value={item.ps_value}
                    listSelect={config.listSelect}
                    idField={config.idField}
                    nameField={config.nameField}
                    onChange={onChange}
                />
            );
        case 'switch':
            return (
                <SwitchItem
                    item={item}
                    colClass={config.colClass}
                    onChange={onChange}
                />
            );
        case 'tableBox':
            return <TableBoxItem item={item} onChange={onChange} />;
        case 'dayRangeSelect':
            return (
                <DayRangeItem
                    item={item}
                    colClass={config.colClass}
                    onChange={onChange}
                />
            );
        default:
            return null;
    }
};

export default SettingItem;
